function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragHandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 481.352,
    height: 287.683,
    fill: "none",
    viewBox: "0 0 15.042 8.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    d: "M10.978 2.383a1.15 1.073 0 1 0 2.3 0 1.15 1.073 0 0 0-2.3 0m-4.598 0a1.15 1.073 0 1 0 2.299 0 1.15 1.073 0 0 0-2.3 0M2.932 3.456a1.15 1.073 0 1 1 0-2.146 1.15 1.073 0 0 1 0 2.146m8.047 3.22a1.15 1.073 0 1 0 2.3 0 1.15 1.073 0 0 0-2.3 0M7.53 7.749a1.15 1.073 0 1 1 0-2.146 1.15 1.073 0 0 1 0 2.146M1.782 6.676a1.15 1.073 0 1 0 2.299 0 1.15 1.073 0 0 0-2.3 0",
    clipRule: "evenodd",
    style: {
      strokeWidth: 0.740473
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragHandle);
export default __webpack_public_path__ + "static/media/drag_handle.36d5cd32eb4104c9dcfa57c010d59f8f.svg";
export { ForwardRef as ReactComponent };